import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  categoryLoad,
  categorySaveChildCategories,
  categorySavePosition,
  categorySetEndPriceMarginRate,
  categoryWebAnalyticsLoad,
  namesDescriptionsSlugsUpdate,
  nameUpdate,
  savePropertyCodes,
  seoUpdate,
  slugsUpdate,
  slugUpdate,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(categoryLoad.type, send, socket);
  yield takeEvery(categorySavePosition.type, send, socket);
  yield takeEvery(savePropertyCodes.type, send, socket);
  yield takeEvery(categorySaveChildCategories.type, send, socket);
  yield takeEvery(nameUpdate.type, send, socket);
  yield takeEvery(namesDescriptionsSlugsUpdate.type, send, socket);
  yield takeEvery(categorySetEndPriceMarginRate.type, send, socket);
  yield takeEvery(seoUpdate.type, send, socket);
  yield takeEvery(slugUpdate.type, send, socket);
  yield takeEvery(slugsUpdate.type, send, socket);
  yield takeEvery(categoryWebAnalyticsLoad.type, send, socket);
}
